'use strict';exports.__esModule = true;var iconLinks = exports.iconLinks = {
  headImage: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto/v1551709388/vr_promotion/head_image',
  headOverlay: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto/v1551708369/vr_promotion/head_overlay',
  headMobileOverlay: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,h_914,w_500,x_300,y_0,c_crop/v1551708369/vr_promotion/head_overlay',
  gswLogo: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto/v1551708373/vr_promotion/gsw_logo_ltr',
  gswLogoRtl: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto/v1551708369/vr_promotion/gsw_logo_rtl',
  holoLogo: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551710853/vr_promotion/Holo_icon',
  holoLogoFull: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551711152/vr_promotion/holo_logo_full',
  arrow: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto/v1551711304/vr_promotion/arrow',
  background: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto/v1551708369/vr_promotion/background',
  laptop: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto/v1551714958/vr_promotion/laptop',
  results: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto/v1551708484/vr_promotion/result',
  time: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto/v1551708484/vr_promotion/time',
  grow: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto/v1551708478/vr_promotion/grow',
  people: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto/v1551782089/vr_promotion/people.png',
  house: 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto/v1551708389/vr_promotion/house',
  underline: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551778183/vr_promotion/underline',
  check: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551780869/vr_promotion/check',
  star: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551796020/vr_promotion/star',
  starBig: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551878229/vr_promotion/star_big',
  house1: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551797304/vr_promotion/house1',
  house2: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551797304/vr_promotion/house2',
  house3: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551797304/vr_promotion/house3',
  house1Mob: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551797304/vr_promotion/house1',
  house2Mob: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551884753/vr_promotion/house4',
  house3Mob: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551884735/vr_promotion/house5',
  clouds: 'https://res.cloudinary.com/onmap-prod/image/upload/v1551797398/vr_promotion/clouds',
  video: 'https://res.cloudinary.com/onmap-prod/video/upload/w_720,q_80/v1551860083/vr_promotion/vr_promotion_video' };


var benefits = exports.benefits = [
{
  title: 'results',
  icon: iconLinks.results,
  description: 'benefitsResults' },

{
  title: 'time',
  icon: iconLinks.time,
  description: 'benefitsTime' },

{
  title: 'grow',
  icon: iconLinks.grow,
  description: 'benefitsGrow' }];



var packages = exports.packages = [
{
  id: 1,
  count: 1,
  price: 899 },

{
  id: 2,
  count: 3,
  oldPrice: 2697,
  price: 2427 },

{
  id: 3,
  count: 5,
  oldPrice: 4495,
  price: 3820 }];


//////////////////
// WEBPACK FOOTER
// ./src/pages/HolomaxPage/config.js
// module id = 3085
// module chunks = 0